// TODO either sync defaults in ui, api, db, or remove these defaults from here
export const DEFAULT_RECENTLY_ACTIVE = 30;
export const DEFAULT_RECENTLY_ACTIVE_DAYS = 30;
export const DEFAULT_RECENTLY_CLOSED = 30;
export const DEFAULT_RECENTLY_CLOSED_DAYS = 30;
export const DEFAULT_TEAM_FOCUSES = 30;
export const DEFAULT_TEAM_RECENTLY_ACTIVE_DAYS = 30;
export const DEFAULT_TEAM_RECENTLY_CLOSED_DAYS = 30;

export interface FocusSelectionParams {
    recentlyActive?: number;
    recentlyActiveDays?: number;
    recentlyClosed?: number;
    recentlyClosedDays?: number;
    teamFocuses?: number;
    teamRecentlyActiveDays?: number;
    teamRecentlyClosedDays?: number;
}
